/**
 * TRIL-542: single predicate for "the reply already has an analysis, so Analyze
 * should re-open it instead of running a new one".
 *
 * Both the early-return guard in handleAnalyzeReply and the Analyze button label
 * read this. They previously each inlined their own variant, and both let
 * `hasStoryAnalysis` escape the re-analyze check — so once an analysis had been
 * saved, editing the reply could never trigger a new one.
 *
 * `reAnalyzeReply` wins over everything: when the content has changed, a stored
 * analysis is stale and must not be reused.
 *
 * REPLY-ONLY. PostDraft.component.tsx:212 still expresses the equivalent inline
 * against `reAnalyzeStory`; it was left alone to keep the TRIL-542 fix surgical,
 * not because the duplication is desirable. Consolidating the two is available
 * as a follow-up — if you do it, note the flags live on different Redux slices.
 */
export const shouldReuseStoredReplyAnalysis = (
  reAnalyzeReply: boolean | undefined,
  showLastAnalysis: boolean,
  hasStoryAnalysis: boolean | undefined,
): boolean => !reAnalyzeReply && (showLastAnalysis || !!hasStoryAnalysis);
